import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import {
  AppBar,
  Badge,
  Box,
  Hidden,
  IconButton,
  Toolbar,
  Typography,
  makeStyles
} from '@material-ui/core';
import MenuIcon from '@material-ui/icons/Menu';
import RefreshRoundedIcon from '@material-ui/icons/RefreshRounded';
import NotificationsIcon from '@material-ui/icons/NotificationsOutlined';
import NavBar from '../navbar/NavBar';
import NavBarAdmin from '../navbar/navbarAdmin/NavBarAdmin';
import Logo from '../../img/LOGO_GMI_aero.png'

const useStyles = makeStyles((theme) => ({
  root: {},
  toolbar: {
    height: 64,
    backgroundColor: 'white'
  },
  title: {
    color: 'var(--gmi-color)',
    [theme.breakpoints.down('xl')]: {
      marginLeft: -70
    },
    [theme.breakpoints.down('lg')]: {
      marginLeft: 20
    },
    [theme.breakpoints.down('md')]: {
      marginLeft: 70,
    },
    [theme.breakpoints.down('sm')]: {
      display: 'none'
    },
    [theme.breakpoints.down('xs')]: {
      display: 'none'
    },
  },
  refresh: {
    margin: "auto"
  },
  spin: {
    margin: "auto",
    animation: "$spin 0.35s 1"
  },
  "@keyframes spin": {
    "0%": {
      transform: "rotate(0deg)"
    },
    "100%": {
      transform: "rotate(360deg)"
    },
  }
}));

const Header = ({ type, title, className, ...rest }) => {
  const classes = useStyles();
  const [isMobileNavOpen, setMobileNavOpen] = useState(false);
  const [spin, setSpin] = useState(0);
  const [notifications] = useState(['hrllo']);

  const refreshPage = () => {
    window.location.reload();
    setSpin(true);
    setTimeout(() => {
      setSpin(false);
    }, 1000);
  }

  return (
    <AppBar
      className={clsx(classes.root, className)}
      elevation={0}
      {...rest}
      >
      <Toolbar className={classes.toolbar}>
        <Link to={ type === "admin" ? "/admin/dashboard" : "/app/dashboard" }>
          <img className="logo" alt="Logo" src={Logo}/>
        </Link>
        <Box flexGrow={1} />

        <Typography variant="h5" className={classes.title}>
          { type === "admin" ? "ReportApp" : `ReportApp - ${title}` }
        </Typography>
        
        

        <Box flexGrow={8} />
        <Hidden false>
          <IconButton color="inherit">
            <Badge
              badgeContent={notifications.length}
              color="primary"
              variant="dot"
              >
              <NotificationsIcon style={{color: 'var(--gmi-color)'}} />
            </Badge>
          </IconButton>
        </Hidden>
        { type === "admin"
          ? (
            <Hidden smDown>
              <IconButton
                color="inherit"
                onClick={refreshPage}
              >
                <Badge
                  className={spin ? classes.spin : classes.refresh}
                  color="primary"
                  spin={spin}
                  >
                  <RefreshRoundedIcon style={{color: 'var(--gmi-color)'}} />
                </Badge>
              </IconButton>
            </Hidden>
            )
          : null
        }

        <Hidden mdUp>
          <IconButton
            color="inherit"
            onClick={() => setMobileNavOpen(true)}
            >
            <MenuIcon style={{color: '#113D78'}} />
          </IconButton>
        </Hidden>
      </Toolbar>
      
      {
        (type === "admin")
          ? (<NavBarAdmin
            onMobileClose={() => setMobileNavOpen(false)}
            openMobile={isMobileNavOpen}
          />)
          : (<NavBar
            onMobileClose={() => setMobileNavOpen(false)}
            openMobile={isMobileNavOpen}
          />)
      }
    </AppBar>
  );
};

Header.propTypes = {
  className: PropTypes.string
};

export default Header;
